import React, { ReactElement, ReactNode, useEffect, useState } from "react";

interface Props {
  delay: number;
  children: React.ReactNode;
}

const DelayedRender: React.FC<Props> = ({ delay, children }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setShow(true);
    }, delay);
  }, []);

  return show ? <>{children}</> : null;
};

export default DelayedRender;
